var __defProp = Object.defineProperty;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/types/design.ts
var MOOD_GUIDANCE;
var init_design = __esm({
  "src/types/design.ts"() {
    MOOD_GUIDANCE = {
      "Modern": "Clean lines, ample white space, contemporary patterns",
      "Professional": "Polished, consistent, attention to detail",
      "Playful": "Rounded shapes, friendly interactions, lighthearted touches",
      "Minimal": "Essential elements only, generous spacing, restrained palette use",
      "Luxurious": "Premium feel, refined details, sophisticated presentation",
      "Trustworthy": "Clear hierarchy, readable typography, familiar patterns",
      "Friendly": "Approachable, warm colors, inviting interactions",
      "Bold": "Strong contrasts, large typography, confident visual statements",
      "Elegant": "Refined details, subtle transitions, sophisticated spacing",
      "Energetic": "Vibrant colors, dynamic layouts, active feeling",
      "Clean": "Uncluttered, focused, clear visual hierarchy",
      "Sophisticated": "Refined aesthetics, balanced composition, mature style",
      "Vibrant": "Rich colors, high energy, lively presence",
      "Warm": "Inviting colors, soft edges, approachable feel",
      "Tech-forward": "Sharp edges, monospace accents, futuristic elements"
    };
  }
});

// src/config/tags.ts
function findTagDefinition(key) {
  for (const def of TAG_DEFINITIONS) {
    if (def.key === key) return def;
    if (def.children) {
      const child = def.children.find((c) => c.key === key);
      if (child) return child;
    }
  }
  return void 0;
}
var TAG_DEFINITIONS;
var init_tags = __esm({
  "src/config/tags.ts"() {
    TAG_DEFINITIONS = [
      // Model Selection (explicit provider + model mapping)
      {
        key: "model",
        label: "Model",
        description: "AI agent and model to use for generation",
        category: "model",
        inputType: "select",
        options: [
          {
            value: "claude-sonnet-5",
            label: "Claude Sonnet 5",
            description: "Anthropic Claude - Best balance of speed and intelligence",
            logo: "/claude.png",
            provider: "claude-code",
            model: "claude-sonnet-5",
            sdk: "agent"
          },
          {
            value: "claude-opus-4-8",
            label: "Claude Opus 4.8",
            description: "Anthropic Claude - Most capable for complex tasks",
            logo: "/claude.png",
            provider: "claude-code",
            model: "claude-opus-4-8",
            sdk: "agent"
          },
          {
            value: "claude-haiku-4-5",
            label: "Claude Haiku 4.5",
            description: "Anthropic Claude - Fastest, good for iterations",
            logo: "/claude.png",
            provider: "claude-code",
            model: "claude-haiku-4-5",
            sdk: "agent"
          },
          {
            value: "gpt-5.2-codex",
            label: "GPT-5.2 Codex",
            description: "OpenAI Codex - Advanced code generation",
            logo: "/openai.png",
            provider: "openai-codex",
            model: "openai/gpt-5.2-codex",
            sdk: "agent"
          },
          {
            value: "factory-droid-opus",
            label: "Factory Droid (Opus)",
            description: "Factory Droid SDK with Claude Opus 4.8",
            logo: "/factory.svg",
            provider: "factory-droid",
            model: "claude-opus-4-8",
            sdk: "droid"
          },
          {
            value: "factory-droid-codex",
            label: "Factory Droid (Codex)",
            description: "Factory Droid SDK with GPT-5.2 Codex",
            logo: "/factory.svg",
            provider: "factory-droid",
            model: "gpt-5.2-codex",
            sdk: "droid"
          },
          {
            value: "factory-droid-glm",
            label: "Factory Droid (GLM)",
            description: "Factory Droid SDK with GLM 4.7",
            logo: "/factory.svg",
            provider: "factory-droid",
            model: "glm-4.7",
            sdk: "droid"
          }
        ]
      },
      // Framework Selection
      {
        key: "framework",
        label: "Framework",
        description: "Frontend framework to use",
        category: "framework",
        inputType: "select",
        options: [
          {
            value: "next",
            label: "Next.js",
            description: "Full-stack React with SSR, App Router, and file-based routing",
            logo: "/logos/nextjs.svg",
            repository: "github:codyde/template-nextjs",
            branch: "main"
          },
          {
            value: "tanstack",
            label: "TanStack Start",
            description: "Minimal TanStack Start foundation with React 19, Router, Query, and Tailwind",
            logo: "/logos/tanstack.png",
            repository: "github:codyde/template-tanstackstart",
            branch: "main"
          },
          {
            value: "vite",
            label: "React + Vite",
            description: "Fast React SPA with Vite - perfect for client-side apps",
            logo: "/logos/react.svg",
            repository: "github:codyde/template-reactvite",
            branch: "main"
          }
        ],
        promptTemplate: "CRITICAL: You MUST use the {label} template. Clone it using: npx degit {repository}#{branch} {{projectName}}"
      },
      // Runner Selection (options populated dynamically)
      {
        key: "runner",
        label: "Runner",
        description: "Build runner to execute the build",
        category: "runner",
        inputType: "select",
        options: []
        // Populated dynamically from connected runners
      },
      // Design Configuration (nested)
      {
        key: "design",
        label: "Design",
        description: "Visual design preferences",
        category: "design",
        inputType: "nested",
        children: [
          // Brand Themes
          {
            key: "brand",
            label: "Brand",
            description: "Pre-configured brand color themes",
            category: "design",
            inputType: "select",
            maxSelections: 1,
            options: [
              {
                value: "stripe",
                label: "Stripe",
                description: "Modern payments aesthetic",
                logo: "/logos/stripe.svg",
                values: {
                  primaryColor: "#635bff",
                  secondaryColor: "#0a2540",
                  accentColor: "#00d4ff",
                  neutralLight: "#f6f9fc",
                  neutralDark: "#0a2540"
                }
              },
              {
                value: "vercel",
                label: "Vercel",
                description: "Clean developer tools",
                logo: "/logos/vercel.svg",
                values: {
                  primaryColor: "#000000",
                  secondaryColor: "#ffffff",
                  accentColor: "#0070f3",
                  neutralLight: "#fafafa",
                  neutralDark: "#000000"
                }
              },
              {
                value: "linear",
                label: "Linear",
                description: "Sleek project management",
                logo: "/logos/linear.svg",
                values: {
                  primaryColor: "#5e6ad2",
                  secondaryColor: "#26b5ce",
                  accentColor: "#f2994a",
                  neutralLight: "#f7f8f8",
                  neutralDark: "#1a1a1a"
                }
              },
              {
                value: "notion",
                label: "Notion",
                description: "Warm productivity",
                logo: "/logos/notion.svg",
                values: {
                  primaryColor: "#2383e2",
                  secondaryColor: "#e69138",
                  accentColor: "#d44c47",
                  neutralLight: "#f7f6f3",
                  neutralDark: "#37352f"
                }
              },
              {
                value: "github",
                label: "GitHub",
                description: "Developer-first",
                logo: "/logos/github.svg",
                values: {
                  primaryColor: "#238636",
                  secondaryColor: "#1f6feb",
                  accentColor: "#f85149",
                  neutralLight: "#f6f8fa",
                  neutralDark: "#24292f"
                }
              },
              {
                value: "airbnb",
                label: "Airbnb",
                description: "Friendly travel",
                logo: "/logos/airbnb.svg",
                values: {
                  primaryColor: "#ff385c",
                  secondaryColor: "#00a699",
                  accentColor: "#fc642d",
                  neutralLight: "#f7f7f7",
                  neutralDark: "#222222"
                }
              },
              {
                value: "spotify",
                label: "Spotify",
                description: "Bold music streaming",
                logo: "/logos/spotify.svg",
                values: {
                  primaryColor: "#1db954",
                  secondaryColor: "#191414",
                  accentColor: "#1ed760",
                  neutralLight: "#f6f6f6",
                  neutralDark: "#000000"
                }
              }
            ],
            promptTemplate: "Use the {value} brand aesthetic with the following color palette: Primary: {primaryColor}, Secondary: {secondaryColor}, Accent: {accentColor}, Neutral Light: {neutralLight}, Neutral Dark: {neutralDark}. Match the design style and feel of {value}."
          }
        ]
      }
    ];
  }
});

// src/lib/tags/resolver.ts
function resolveTags(appliedTags) {
  const resolved = {};
  try {
    if (!appliedTags || !Array.isArray(appliedTags)) {
      console.warn("[resolveTags] Invalid appliedTags:", appliedTags);
      return resolved;
    }
    const brandTag = appliedTags.find((t) => t.key === "brand");
    if (brandTag?.expandedValues) {
      Object.assign(resolved, brandTag.expandedValues);
      resolved.brand = brandTag.value;
    }
    const modelTag = appliedTags.find((t) => t.key === "model");
    if (modelTag) {
      resolved.model = modelTag.value;
    }
    const frameworkTag = appliedTags.find((t) => t.key === "framework");
    if (frameworkTag) {
      resolved.framework = frameworkTag.value;
    }
    const runnerTag = appliedTags.find((t) => t.key === "runner");
    if (runnerTag) {
      resolved.runner = runnerTag.value;
    }
    return resolved;
  } catch (error) {
    console.error("[resolveTags] Error resolving tags:", error);
    return resolved;
  }
}
function generatePromptFromTags(resolved, projectName, isNewProject) {
  const sections = [];
  sections.push(`\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550
\u{1F3AF} USER-SPECIFIED DESIGN (HIGHEST PRIORITY - OVERRIDES ALL DEFAULTS)
\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550

CRITICAL PRIORITY LEVELS:
[PRIORITY 1] User's explicit tag selections (below) - MUST be implemented exactly
[PRIORITY 2] Template functionality and structure - keep this  
[PRIORITY 3] Base design system defaults - use only if no tags specified

${isNewProject ? `
\u26A0\uFE0F  TEMPLATE TRANSFORMATION REQUIRED \u26A0\uFE0F

You are working with a template that has its own existing design.
Your job: TRANSFORM the template's visual design to match the specifications below.

DO NOT just add styles on top - REPLACE the template's design language:
- Modify the template's CSS/styling files 
- Update component designs (buttons, cards, layouts, navigation)
- Change visual aesthetics while preserving functionality
- The template STRUCTURE is fine, but its VISUAL DESIGN must change
` : ""}`);
  if (resolved.framework) {
    const frameworkDef = findTagDefinition("framework");
    const frameworkOption = frameworkDef?.options?.find((o) => o.value === resolved.framework);
    if (frameworkOption && frameworkDef?.promptTemplate) {
      let prompt = frameworkDef.promptTemplate.replace("{label}", frameworkOption.label).replace("{value}", frameworkOption.value).replace("{repository}", frameworkOption.repository || "").replace("{branch}", frameworkOption.branch || "main").replace("{{projectName}}", projectName || "<project-name>");
      sections.push(`## Framework Requirement (MANDATORY)

${prompt}`);
    } else {
      sections.push(`## Framework Requirement (MANDATORY)

CRITICAL: The user has explicitly selected ${resolved.framework} as the framework.
You MUST use ${resolved.framework} for this project. Do NOT suggest or use any other framework.

Set up the project structure according to ${resolved.framework} best practices and conventions.`);
    }
  }
  if (resolved.brand) {
    sections.push("\n## Design Constraints (MANDATORY - User-Specified)\n");
    sections.push("CRITICAL: The user has explicitly configured these design preferences. Follow these specifications precisely:\n");
    const brandDef = findTagDefinition("brand");
    const brandOption = brandDef?.options?.find((o) => o.value === resolved.brand);
    if (brandOption) {
      sections.push(`**Brand Aesthetic (MANDATORY):**`);
      sections.push(`Match the visual style and feel of ${brandOption.label} (${brandOption.description}).`);
    }
    sections.push(`
**Color Palette (MANDATORY - DO NOT DEVIATE):**`);
    sections.push(`- Primary: ${resolved.primaryColor} (use for CTAs, primary buttons, brand elements)`);
    sections.push(`- Secondary: ${resolved.secondaryColor} (use for secondary actions, supporting elements)`);
    sections.push(`- Accent: ${resolved.accentColor} (use for highlights, badges, important elements)`);
    sections.push(`- Neutral Light: ${resolved.neutralLight} (use for light backgrounds, cards, containers)`);
    sections.push(`- Neutral Dark: ${resolved.neutralDark} (use for text, dark backgrounds, borders)`);
    sections.push(`
You MUST use ONLY these 5 colors. Do NOT introduce any additional colors outside this palette.`);
    sections.push("\n**Technical Requirements:**");
    sections.push("- Define all colors as CSS custom properties (e.g., --color-primary, --color-secondary)");
    sections.push("- NEVER hardcode hex values directly in components");
    sections.push("- Use semantic color names that reference the custom properties");
    sections.push("- NEVER use emojis in the UI. Instead, use Lucide React icons for all visual elements");
  } else {
    sections.push("\n**UI Guidelines:**");
    sections.push("- NEVER use emojis in the UI. Instead, use Lucide React icons for all visual elements");
  }
  return sections.filter((s) => s).join("\n");
}
var init_resolver = __esm({
  "src/lib/tags/resolver.ts"() {
    init_tags();
  }
});

// src/lib/agents/claude-strategy.ts
var claude_strategy_exports = {};
__export(claude_strategy_exports, {
  default: () => claude_strategy_default
});
function buildClaudeSections(context) {
  const sections = [];
  if (context.tags && context.tags.length > 0) {
    const resolved = resolveTags(context.tags);
    const tagPrompt = generatePromptFromTags(resolved, context.projectName, context.isNewProject);
    if (tagPrompt) {
      sections.push(tagPrompt);
    }
  } else if (context.designPreferences) {
    const prefs = context.designPreferences;
    const moodGuidance = prefs.mood.map((m) => `- ${m}: ${MOOD_GUIDANCE[m] || ""}`).join("\n");
    sections.push(`## Design Constraints (User-Specified)

CRITICAL: The user has specified EXACT design preferences. Follow these specifications precisely:

**Color Palette (MANDATORY - DO NOT DEVIATE):**
- Primary: ${prefs.colors.primary} (use for CTAs, primary buttons, brand elements)
- Secondary: ${prefs.colors.secondary} (use for secondary actions, supporting elements)
- Accent: ${prefs.colors.accent} (use for highlights, badges, important elements)
- Neutral Light: ${prefs.colors.neutralLight} (use for light backgrounds, cards, containers)
- Neutral Dark: ${prefs.colors.neutralDark} (use for text, dark backgrounds, borders)

You MUST use ONLY these colors. Define them as CSS custom properties in your design system:

\`\`\`css
:root {
  --color-primary: ${prefs.colors.primary};
  --color-secondary: ${prefs.colors.secondary};
  --color-accent: ${prefs.colors.accent};
  --color-neutral-light: ${prefs.colors.neutralLight};
  --color-neutral-dark: ${prefs.colors.neutralDark};
}
\`\`\`

**Typography (MANDATORY):**
- Heading Font: ${prefs.typography.heading} (use for all h1, h2, h3, h4, h5, h6)
- Body Font: ${prefs.typography.body} (use for paragraphs, labels, body text, UI elements)

Import these fonts from Google Fonts or use system fonts as specified.

**Style Direction:**
The user wants a design that feels: ${prefs.mood.join(", ")}

Interpret these mood descriptors to guide your design decisions:
${moodGuidance}

**Critical Reminders:**
- Do NOT add any colors outside the specified 5-color palette
- Do NOT use any fonts other than the 2 specified
- Match the mood descriptors in your typography scale, spacing, and component design
- Define colors as CSS variables, never use hex values directly in components`);
  }
  if (context.isNewProject) {
    sections.push(`## New Project: Template Prepared

- Project name: ${context.projectName}
- Location: ${context.workingDirectory}
- Operation type: ${context.operationType}

The template has already been downloaded. Customize the scaffold to satisfy the request; follow the dependency-state instructions below for installation.`);
  } else {
    let existingProjectSection = `## Existing Project Context

- Project location: ${context.workingDirectory}
- Operation type: ${context.operationType}

Review the current codebase and apply the requested changes without re-scaffolding.`;
    if (context.conversationHistory && context.conversationHistory.length > 0) {
      existingProjectSection += `

**Recent Conversation History:**
`;
      existingProjectSection += `You have access to the recent conversation history. Use this to understand the context and what has been discussed:

`;
      context.conversationHistory.forEach((msg, index) => {
        const roleLabel = msg.role === "user" ? "User" : "Assistant";
        const timestamp = msg.timestamp instanceof Date ? msg.timestamp.toISOString() : msg.timestamp;
        const content = msg.content.length > 500 ? msg.content.substring(0, 500) + "...[truncated]" : msg.content;
        existingProjectSection += `${index + 1}. ${roleLabel} (${timestamp}):
${content}

`;
      });
      existingProjectSection += `Use this conversation history to understand:
- What has been built or discussed so far
- The user's preferences and requirements
- References to "it", "the app", "the project", etc.
- Any previous decisions or implementations

Apply the current request in the context of this conversation.`;
    }
    sections.push(existingProjectSection);
  }
  sections.push(`## Workspace Rules
- Use relative paths within the project.
- Work inside the existing project structure.
- Provide complete updates without placeholders.`);
  if (context.fileTree) {
    sections.push(`## Project Manifest
${context.fileTree}`);
  }
  if (context.templateName) {
    sections.push(`## Template Details
- Template: ${context.templateName}
- Framework: ${context.templateFramework ?? "unknown"}`);
  }
  return sections;
}
function buildFullPrompt(context, basePrompt) {
  if (!context.isNewProject) {
    if (context.operationType === "autofix") {
      return `${basePrompt}

## Autofix Speed Rules
1. Diagnose from the error first; only open files implicated by the stack/log.
2. Make the smallest fix that restores startup; avoid refactors and design changes.
3. Re-run the failing command once, fix remaining errors, then stop.`;
    }
    return basePrompt;
  }
  return `${basePrompt}

CRITICAL: The template has already been prepared in ${context.workingDirectory}. Do not scaffold a new project.

## Speed Rules
1. Emit one short TodoWrite plan (\u22648 items), then implement immediately.
2. Use WebSearch/WebFetch only for missing external docs/API details; do not explore alternative architectures.
3. One dependency install after package.json changes; one build/typecheck; fix only real failures.
4. Finish when the request is met and validation is clean \u2014 no extra polish turns.`;
}
var claudeStrategy, claude_strategy_default;
var init_claude_strategy = __esm({
  "src/lib/agents/claude-strategy.ts"() {
    init_design();
    init_resolver();
    claudeStrategy = {
      buildSystemPromptSections: buildClaudeSections,
      buildFullPrompt,
      shouldDownloadTemplate(context) {
        return context.isNewProject && !context.skipTemplates;
      },
      postTemplateSelected(context, template) {
        context.templateName = template.name;
        context.templateFramework = template.framework;
        context.fileTree = template.fileTree;
      }
    };
    claude_strategy_default = claudeStrategy;
  }
});

// src/lib/agents/codex/template-catalog.ts
function buildCodexTemplateCatalogSection(catalog) {
  return `## Template Catalog
${catalog}`;
}
var init_template_catalog = __esm({
  "src/lib/agents/codex/template-catalog.ts"() {
  }
});

// src/lib/agents/codex/events.ts
function sortPhases(phases) {
  return [...phases].sort((a, b) => {
    const idxA = CODEX_PHASE_ORDER.indexOf(a.id);
    const idxB = CODEX_PHASE_ORDER.indexOf(b.id);
    const safeA = idxA === -1 ? CODEX_PHASE_ORDER.length + 1 : idxA;
    const safeB = idxB === -1 ? CODEX_PHASE_ORDER.length + 1 : idxB;
    if (safeA === safeB) {
      return (a.title ?? "").localeCompare(b.title ?? "");
    }
    return safeA - safeB;
  });
}
function toStringOr(value, fallback) {
  if (value === void 0 || value === null) return fallback;
  return String(value);
}
function toOptionalString(value) {
  if (value === void 0 || value === null) return void 0;
  return String(value);
}
function toOptionalStringArray(values) {
  if (!Array.isArray(values)) return void 0;
  const mapped = values.map((value) => toOptionalString(value)?.trim()).filter((item) => !!item);
  return mapped.length > 0 ? mapped : void 0;
}
function processCodexEvent(state, rawEvent) {
  const timestampValue = rawEvent.timestamp;
  const timestamp = timestampValue ? new Date(timestampValue) : /* @__PURE__ */ new Date();
  switch (rawEvent.type) {
    case "codex-phase-start": {
      const phaseId = rawEvent.phaseId;
      if (!phaseId) return state;
      let found = false;
      const phases = state.phases.map((phase) => {
        if (phase.id === phaseId) {
          found = true;
          return {
            ...phase,
            title: toOptionalString(rawEvent.title) ?? phase.title,
            description: toOptionalString(rawEvent.description) ?? phase.description,
            status: "active",
            startedAt: phase.startedAt ?? timestamp,
            spotlight: toOptionalString(rawEvent.spotlight) ?? phase.spotlight
          };
        }
        if (phase.status === "active" && phase.completedAt === void 0) {
          return {
            ...phase,
            status: "completed",
            completedAt: timestamp
          };
        }
        return phase;
      });
      const next = found ? phases : [
        ...phases,
        {
          id: phaseId,
          title: toStringOr(rawEvent.title, "In Progress"),
          description: toStringOr(rawEvent.description, ""),
          status: "active",
          startedAt: timestamp,
          spotlight: toOptionalString(rawEvent.spotlight)
        }
      ];
      return {
        ...state,
        phases: sortPhases(next)
      };
    }
    case "codex-phase-complete": {
      const phaseId = rawEvent.phaseId;
      if (!phaseId) return state;
      return {
        ...state,
        phases: sortPhases(
          state.phases.map(
            (phase) => phase.id === phaseId ? {
              ...phase,
              title: toOptionalString(rawEvent.title) ?? phase.title,
              description: toOptionalString(rawEvent.description) ?? phase.description,
              status: "completed",
              completedAt: timestamp,
              spotlight: toOptionalString(rawEvent.spotlight) ?? phase.spotlight
            } : phase
          )
        )
      };
    }
    case "codex-phase-blocked": {
      const phaseId = rawEvent.phaseId;
      if (!phaseId) return state;
      return {
        ...state,
        phases: state.phases.map(
          (phase) => phase.id === phaseId ? {
            ...phase,
            status: "blocked",
            spotlight: toOptionalString(rawEvent.reason) ?? toOptionalString(rawEvent.spotlight) ?? phase.spotlight
          } : phase
        )
      };
    }
    case "codex-phase-spotlight": {
      const phaseId = rawEvent.phaseId;
      if (!phaseId || !rawEvent.spotlight) return state;
      return {
        ...state,
        phases: state.phases.map(
          (phase) => phase.id === phaseId ? { ...phase, spotlight: toOptionalString(rawEvent.spotlight) ?? phase.spotlight } : phase
        )
      };
    }
    case "codex-template-decision": {
      return {
        ...state,
        templateDecision: {
          templateId: toStringOr(rawEvent.templateId, "unknown-template"),
          templateName: toOptionalString(rawEvent.templateName) ?? toOptionalString(rawEvent.displayName) ?? "Selected Template",
          repository: toOptionalString(rawEvent.repository),
          branch: toOptionalString(rawEvent.branch),
          confidence: typeof rawEvent.confidence === "number" ? rawEvent.confidence : void 0,
          rationale: toOptionalString(rawEvent.rationale) ?? toOptionalString(rawEvent.reason),
          decidedAt: timestamp
        }
      };
    }
    case "codex-workspace-verified": {
      return {
        ...state,
        workspaceVerification: {
          directory: toOptionalString(rawEvent.directory) ?? toOptionalString(rawEvent.path) ?? "",
          exists: rawEvent.exists !== void 0 ? Boolean(rawEvent.exists) : true,
          discoveredEntries: toOptionalStringArray(rawEvent.entries),
          notes: toOptionalString(rawEvent.notes) ?? toOptionalString(rawEvent.summary),
          verifiedAt: timestamp
        }
      };
    }
    case "codex-task-summary": {
      const bullets = Array.isArray(rawEvent.bullets) ? toOptionalStringArray(rawEvent.bullets) ?? [] : typeof rawEvent.summary === "string" ? rawEvent.summary.split("\n").map((line) => line.trim()).filter(Boolean) : [];
      return {
        ...state,
        taskSummary: {
          headline: toOptionalString(rawEvent.headline) ?? toOptionalString(rawEvent.title) ?? "Key Tasks Identified",
          bullets,
          capturedAt: timestamp
        }
      };
    }
    case "codex-execution-insight": {
      const text = rawEvent.text ?? rawEvent.message ?? "";
      if (!text) return state;
      const tone = ["success", "warning", "error", "info"].includes(
        toStringOr(rawEvent.tone, "")
      ) ? rawEvent.tone : "info";
      const insight = {
        id: toOptionalString(rawEvent.id) ?? `insight-${Date.now()}`,
        text: toStringOr(text, ""),
        tone,
        timestamp
      };
      const existing = state.executionInsights ?? [];
      const existingIndex = existing.findIndex((item) => item.id === insight.id);
      const nextInsights = existingIndex >= 0 ? existing.map((item) => item.id === insight.id ? insight : item) : [...existing.slice(-19), insight];
      return {
        ...state,
        executionInsights: nextInsights
      };
    }
    default:
      return state;
  }
}
var CODEX_PHASE_ORDER;
var init_events = __esm({
  "src/lib/agents/codex/events.ts"() {
    CODEX_PHASE_ORDER = [
      "prompt-analysis",
      "template-selection",
      "template-clone",
      "workspace-verification",
      "task-synthesis",
      "execution"
    ];
  }
});

// src/lib/templates/config.server.ts
var config_server_exports = {};
__export(config_server_exports, {
  getAllTemplates: () => getAllTemplates,
  getTemplateById: () => getTemplateById,
  getTemplateSelectionContext: () => getTemplateSelectionContext,
  loadTemplateConfig: () => loadTemplateConfig,
  selectTemplateFromPrompt: () => selectTemplateFromPrompt,
  setTemplatesPath: () => setTemplatesPath
});
import { readFile } from "fs/promises";
import { join } from "path";
function setTemplatesPath(path) {
  configuredPath = path;
  process.env.TEMPLATES_JSON_PATH = path;
  cachedConfig = null;
}
function getTemplatesPath() {
  const path = configuredPath ?? process.env.TEMPLATES_JSON_PATH ?? join(process.cwd(), "templates.json");
  if (process.env.DEBUG_TEMPLATES === "1") {
    console.log("[templates] getTemplatesPath called:");
    console.log(`  configuredPath: ${configuredPath}`);
    console.log(`  env.TEMPLATES_JSON_PATH: ${process.env.TEMPLATES_JSON_PATH}`);
    console.log(`  resolved path: ${path}`);
  }
  return path;
}
async function loadTemplateConfig() {
  if (cachedConfig) {
    return cachedConfig;
  }
  const configPath = getTemplatesPath();
  const content = await readFile(configPath, "utf-8");
  cachedConfig = JSON.parse(content);
  console.log(`\u2705 Loaded ${cachedConfig.templates.length} templates from ${configPath}`);
  return cachedConfig;
}
async function getTemplateById(id) {
  const config = await loadTemplateConfig();
  return config.templates.find((t) => t.id === id) ?? null;
}
async function getAllTemplates() {
  const config = await loadTemplateConfig();
  return config.templates;
}
async function getTemplateSelectionContext() {
  const templates = await getAllTemplates();
  let context = "\u{1F3AF} AVAILABLE TEMPLATES:\n\n";
  for (const template of templates) {
    context += `**${template.name}** (ID: ${template.id})
`;
    context += `${template.description}

`;
    context += `\u{1F4E6} Clone command:
`;
    context += `  npx degit ${template.repository}#${template.branch} "<project-name>"

`;
    context += `Best for:
${template.selection.useCases.map((uc) => `  \u2022 ${uc}`).join("\n")}

`;
    context += `Example user requests:
${template.selection.examples.map((ex) => `  \u2022 "${ex}"`).join("\n")}

`;
    context += `Tech Stack: ${template.tech.framework} ${template.tech.version}, ${template.tech.language}, ${template.tech.styling}`;
    if (template.tech.uiLibrary) {
      context += `, ${template.tech.uiLibrary}`;
    }
    context += "\n\n";
    context += "---\n\n";
  }
  return context;
}
async function selectTemplateFromPrompt(userPrompt) {
  const templates = await getAllTemplates();
  const prompt = userPrompt.toLowerCase();
  const scores = templates.map((template) => {
    const keywords = template.selection.keywords;
    const matches = keywords.filter(
      (keyword) => prompt.includes(keyword.toLowerCase())
    );
    return {
      template,
      score: matches.length,
      matchedKeywords: matches
    };
  });
  scores.sort((a, b) => b.score - a.score);
  if (scores[0].score > 0) {
    console.log(`\u{1F3AF} Auto-selected template: ${scores[0].template.name}`);
    console.log(`   Matched keywords: ${scores[0].matchedKeywords.join(", ")}`);
    return scores[0].template;
  }
  console.log(`\u{1F3AF} No keyword matches, defaulting to react-vite (basic template)`);
  return templates.find((t) => t.id === "react-vite") ?? templates[0];
}
var cachedConfig, configuredPath;
var init_config_server = __esm({
  "src/lib/templates/config.server.ts"() {
    cachedConfig = null;
  }
});

// src/lib/templates/load-template-context.server.ts
var load_template_context_server_exports = {};
__export(load_template_context_server_exports, {
  loadTemplateSelectionContext: () => loadTemplateSelectionContext
});
async function loadTemplateSelectionContext(context) {
  if (context.templateSelectionContext) {
    return context.templateSelectionContext;
  }
  if (typeof window !== "undefined") {
    return void 0;
  }
  const { getTemplateSelectionContext: getTemplateSelectionContext2 } = await Promise.resolve().then(() => (init_config_server(), config_server_exports));
  return getTemplateSelectionContext2();
}
var init_load_template_context_server = __esm({
  "src/lib/templates/load-template-context.server.ts"() {
  }
});

// src/lib/templates/load-template-context.ts
async function loadTemplateSelectionContext2(context) {
  if (context.templateSelectionContext) {
    return context.templateSelectionContext;
  }
  if (typeof window !== "undefined") {
    return void 0;
  }
  const loader = await Promise.resolve().then(() => (init_load_template_context_server(), load_template_context_server_exports));
  return loader.loadTemplateSelectionContext(context);
}
var init_load_template_context = __esm({
  "src/lib/templates/load-template-context.ts"() {
  }
});

// src/lib/agents/codex-strategy.ts
var codex_strategy_exports = {};
__export(codex_strategy_exports, {
  default: () => codex_strategy_default
});
function getParentDirectory(filePath) {
  if (!filePath) return filePath;
  const normalized = filePath.replace(/\\/g, "/");
  const trimmed = normalized.replace(/\/+$|\/+$|\/*$/, "");
  const lastSlash = trimmed.lastIndexOf("/");
  if (lastSlash <= 0) {
    return "/";
  }
  return trimmed.slice(0, lastSlash);
}
function buildCodexSections(context) {
  const sections = [];
  if (context.tags && context.tags.length > 0) {
    const resolved = resolveTags(context.tags);
    const tagPrompt = generatePromptFromTags(resolved, context.projectName, context.isNewProject);
    if (tagPrompt) {
      sections.push(tagPrompt);
    }
  }
  if (context.isNewProject) {
    if (context.templateMetadata) {
      sections.push(`## Template Already Selected

- Template: ${context.templateName ?? "Selected template"}
- Repository: ${context.templateMetadata.repository}#${context.templateMetadata.branch}
- The template has been chosen based on your analysis of the user's request
- Clone command: npx degit ${context.templateMetadata.repository}#${context.templateMetadata.branch} ${context.projectName}
- CRITICAL: After cloning, prefix EVERY bash command with "cd ${context.projectName} &&"
- Follow the setup instructions exactly before implementing the request`);
    } else {
      sections.push(`## Template Selection and Setup

- Codex selects the appropriate template using the provided catalog
- After cloning, prefix EVERY bash command with "cd ${context.projectName} &&"
- Remember: bash commands run in fresh shells - cd does not persist
- Follow the setup instructions exactly before implementing the request`);
    }
  } else {
    let existingProjectSection = `## Existing Project Context

- Project location: ${context.workingDirectory}
- Modify the existing codebase to satisfy the request.`;
    if (context.conversationHistory && context.conversationHistory.length > 0) {
      existingProjectSection += `

**Recent Conversation History:**
`;
      existingProjectSection += `You have access to recent conversation history. Use this to understand context:

`;
      context.conversationHistory.forEach((msg, index) => {
        const roleLabel = msg.role === "user" ? "User" : "Assistant";
        const timestamp = msg.timestamp instanceof Date ? msg.timestamp.toISOString() : msg.timestamp;
        const content = msg.content.length > 500 ? msg.content.substring(0, 500) + "...[truncated]" : msg.content;
        existingProjectSection += `${index + 1}. ${roleLabel} (${timestamp}):
${content}

`;
      });
      existingProjectSection += `Use this history to understand:
- What has been built or discussed
- User preferences and requirements
- References to "it", "the app", "the project"
- Previous decisions or implementations

Apply the current request in context of this conversation.`;
    }
    sections.push(existingProjectSection);
  }
  sections.push(`## Workspace Rules
- ${context.isNewProject ? `After cloning, prefix ALL bash commands with "cd ${context.projectName} &&"` : "Operate inside the workspace directory"}
- Each bash command runs in a fresh shell - cd does not persist between commands
- ${context.isNewProject ? `Example: bash -lc 'cd ${context.projectName} && npm install --prefer-offline --no-audit --no-fund'` : "Use relative paths for file operations"}
- Provide complete file contents for every modification`);
  sections.push(`## Task Tracking - Internal System (NOT A TOOL)

IMPORTANT: Task tracking is done by including JSON in your text responses.
This is NOT a tool to call, NOT a command to run, NOT something to install.

Simply include a JSON code block in your response like this:

\`\`\`json
{"todos":[
  {"content":"Clone template","status":"completed","activeForm":"Cloned template"},
  {"content":"Implement features","status":"in_progress","activeForm":"Implementing features"},
  {"content":"Install dependencies once","status":"pending","activeForm":"Installing dependencies"}
]}
\`\`\`

The system automatically extracts this from your response text.
DO NOT try to call it as a tool, run it as a command, or install it as a binary.
Just include the JSON code block in your message.`);
  if (context.templateSelectionContext && !context.templateMetadata) {
    sections.push(buildCodexTemplateCatalogSection(context.templateSelectionContext));
  }
  return sections;
}
function buildFullPrompt2(context, basePrompt) {
  if (!context.isNewProject) {
    return basePrompt;
  }
  if (context.templateMetadata) {
    const { repository, branch } = context.templateMetadata;
    return `USER REQUEST: ${basePrompt}

WORKFLOW INSTRUCTIONS:

You will complete this request in ONE continuous session by following these exact steps:

STEP 1: CREATE TASK BREAKDOWN
First, analyze the request and determine what specific tasks need to be done.

Create AS MANY TASKS AS NEEDED to properly build the MVP. This could be:
- Simple request: 3-4 tasks
- Medium request: 5-8 tasks
- Complex request: 10-15+ tasks

Think through ALL the work required.

Then include a JSON code block in your response:
\`\`\`json
{"todos":[
  {"content":"Clone and configure template","status":"in_progress","activeForm":"Cloning and configuring template"},
  {"content":"Implement features","status":"pending","activeForm":"Implementing features"},
  {"content":"Install dependencies once","status":"pending","activeForm":"Installing dependencies"},
  ...as many as needed...
  {"content":"Verify build","status":"pending","activeForm":"Verifying build"}
]}
\`\`\`

The system will automatically extract this. Do NOT try to call it as a tool or command.

STEP 2: CLONE AND CONFIGURE
   bash -lc 'npx degit ${repository}#${branch} ${context.projectName}'
   bash -lc 'ls ${context.projectName}'
   bash -lc 'cd ${context.projectName} && cat > .npmrc << EOF
save-exact=true
legacy-peer-deps=false
engine-strict=true
EOF'
   bash -lc 'cd ${context.projectName} && npm pkg set name="${context.projectName}"'

After setup, include updated JSON code block (mark setup as "completed")

STEP 3: IMPLEMENT ALL FEATURES AND DEPENDENCY CHANGES
   - Modify template files to deliver the requested functionality
   - Use: bash -lc 'cd ${context.projectName} && cat > filepath << EOF
...
EOF'
   - Implement EVERY requested feature completely
   - Finish all package.json dependency changes before installing
   - After each major feature, include updated JSON code block

STEP 4: INSTALL DEPENDENCIES ONCE
   bash -lc 'cd ${context.projectName} && npm install --prefer-offline --no-audit --no-fund'

After installing, include updated JSON code block

STEP 5: VERIFY BUILD
   bash -lc 'cd ${context.projectName} && npm run build'

After successful build, include final JSON code block with all tasks "completed"

CRITICAL: You MUST complete ALL 5 steps in this single session.
Each bash command runs in a fresh shell - prefix with "cd ${context.projectName} &&"
Only respond "Implementation complete" after ALL steps are verified.`;
  }
  return `USER REQUEST: ${basePrompt}

WORKFLOW INSTRUCTIONS:

You will complete this request in ONE continuous session by following these exact steps:

STEP 1: CREATE TASK BREAKDOWN
First, analyze the request and determine what tasks are needed.

Create AS MANY TASKS AS NEEDED to properly build the MVP. This could be:
- Simple request: 3-4 tasks
- Medium request: 5-8 tasks
- Complex request: 10-15+ tasks

Think through ALL the work required.

Then include a JSON code block in your response:
\`\`\`json
{"todos":[
  {"content":"Select and clone template","status":"in_progress","activeForm":"Selecting and cloning template"},
  ...as many tasks as needed...
  {"content":"Install dependencies once","status":"pending","activeForm":"Installing dependencies"},
  {"content":"Verify build","status":"pending","activeForm":"Verifying build"}
]}
\`\`\`

The system automatically extracts this. Do NOT try to call it as a tool or command.

STEP 2: CLONE AND CONFIGURE
   Choose appropriate template from available options
   bash -lc 'npx degit <repository>#<branch> ${context.projectName}'
   bash -lc 'ls ${context.projectName}'
   bash -lc 'cd ${context.projectName} && cat > .npmrc << EOF
save-exact=true
EOF'
   bash -lc 'cd ${context.projectName} && npm pkg set name="${context.projectName}"'

After setup, include updated JSON code block (mark setup as "completed")

STEP 3: IMPLEMENT ALL FEATURES AND DEPENDENCY CHANGES
   - Modify template files to deliver requested functionality
   - ALL commands: bash -lc 'cd ${context.projectName} && ...'
   - Implement EVERY requested feature completely
   - Finish all package.json dependency changes before installing
   - After each major feature, include updated JSON code block

STEP 4: INSTALL DEPENDENCIES ONCE
   bash -lc 'cd ${context.projectName} && npm install --prefer-offline --no-audit --no-fund'

After installing, include updated JSON code block

STEP 5: VERIFY BUILD
   bash -lc 'cd ${context.projectName} && npm run build'

After successful build, include final JSON code block with all tasks "completed"

CRITICAL: Complete ALL 5 steps in this single session.
Each bash command runs in a fresh shell - prefix with "cd ${context.projectName} &&"
Only respond "Implementation complete" after ALL steps are verified.`;
}
var codexStrategy, codex_strategy_default;
var init_codex_strategy = __esm({
  "src/lib/agents/codex-strategy.ts"() {
    init_template_catalog();
    init_events();
    init_load_template_context();
    init_resolver();
    codexStrategy = {
      buildSystemPromptSections: buildCodexSections,
      buildFullPrompt: buildFullPrompt2,
      shouldDownloadTemplate() {
        return false;
      },
      resolveWorkingDirectory(context) {
        if (!context.isNewProject) {
          return context.workingDirectory;
        }
        return getParentDirectory(context.workingDirectory);
      },
      async getTemplateSelectionContext(context) {
        return loadTemplateSelectionContext2(context);
      },
      processRunnerEvent(state, event) {
        if (!state || typeof state !== "object") {
          return state;
        }
        const codexLike = state;
        if (!Array.isArray(codexLike?.phases)) {
          return state;
        }
        const next = processCodexEvent(codexLike, event);
        return next;
      }
    };
    codex_strategy_default = codexStrategy;
  }
});

// src/lib/agents/droid-strategy.ts
var droid_strategy_exports = {};
__export(droid_strategy_exports, {
  default: () => droid_strategy_default
});
function buildDroidSections(context) {
  const sections = [];
  if (context.tags && context.tags.length > 0) {
    const resolved = resolveTags(context.tags);
    const tagPrompt = generatePromptFromTags(resolved, context.projectName, context.isNewProject);
    if (tagPrompt) {
      sections.push(tagPrompt);
    }
  }
  if (context.isNewProject) {
    sections.push(`## New Project Setup

- Project name: ${context.projectName}
- Location: ${context.workingDirectory}
- Operation type: ${context.operationType}

The template has already been downloaded. Customize the scaffold to satisfy the request; follow the dependency-state instructions below for installation.`);
  } else {
    let existingProjectSection = `## Existing Project Context

- Project location: ${context.workingDirectory}
- Operation type: ${context.operationType}

Review the current codebase and apply the requested changes without re-scaffolding.`;
    if (context.conversationHistory && context.conversationHistory.length > 0) {
      existingProjectSection += `

**Recent Conversation History:**
`;
      context.conversationHistory.forEach((msg, index) => {
        const roleLabel = msg.role === "user" ? "User" : "Assistant";
        const content = msg.content.length > 500 ? msg.content.substring(0, 500) + "...[truncated]" : msg.content;
        existingProjectSection += `${index + 1}. ${roleLabel}:
${content}

`;
      });
    }
    sections.push(existingProjectSection);
  }
  sections.push(`## Workspace Rules
- Use relative paths within the project.
- Work inside the existing project structure.
- Provide complete file contents without placeholders.`);
  if (context.fileTree) {
    sections.push(`## Project Manifest
${context.fileTree}`);
  }
  if (context.templateName) {
    sections.push(`## Template
- Name: ${context.templateName}
- Framework: ${context.templateFramework ?? "unknown"}`);
  }
  return sections;
}
function buildFullPrompt3(context, basePrompt) {
  if (!context.isNewProject) {
    return basePrompt;
  }
  return `${basePrompt}

CRITICAL: The template has already been prepared in ${context.workingDirectory}. Do not scaffold a new project.`;
}
var droidStrategy, droid_strategy_default;
var init_droid_strategy = __esm({
  "src/lib/agents/droid-strategy.ts"() {
    init_resolver();
    droidStrategy = {
      buildSystemPromptSections: buildDroidSections,
      buildFullPrompt: buildFullPrompt3,
      shouldDownloadTemplate(context) {
        return context.isNewProject && !context.skipTemplates;
      },
      postTemplateSelected(context, template) {
        context.templateName = template.name;
        context.templateFramework = template.framework;
        context.fileTree = template.fileTree;
      }
    };
    droid_strategy_default = droidStrategy;
  }
});

// src/lib/agents/strategy.ts
var strategyRegistry = /* @__PURE__ */ new Map();
function registerAgentStrategy(agentId, strategy) {
  strategyRegistry.set(agentId, strategy);
}
function getAgentStrategy(agentId) {
  const strategy = strategyRegistry.get(agentId);
  if (!strategy) {
    throw new Error(`No strategy registered for agent: ${agentId}`);
  }
  return strategy;
}

// src/lib/agents/index.ts
var initialized = false;
async function ensureRegistry() {
  if (initialized) {
    return;
  }
  const [
    { default: claudeStrategy2 },
    { default: codexStrategy2 },
    { default: droidStrategy2 }
  ] = await Promise.all([
    Promise.resolve().then(() => (init_claude_strategy(), claude_strategy_exports)),
    Promise.resolve().then(() => (init_codex_strategy(), codex_strategy_exports)),
    Promise.resolve().then(() => (init_droid_strategy(), droid_strategy_exports))
  ]);
  registerAgentStrategy("claude-code", claudeStrategy2);
  registerAgentStrategy("openai-codex", codexStrategy2);
  registerAgentStrategy("factory-droid", droidStrategy2);
  initialized = true;
}
async function resolveAgentStrategy(agentId) {
  await ensureRegistry();
  return getAgentStrategy(agentId);
}
export {
  getAgentStrategy,
  registerAgentStrategy,
  resolveAgentStrategy
};
//# sourceMappingURL=index.js.map